import { render, staticRenderFns } from "./btn-outline-primary-active.mpx?vue&type=template&id=c6ade7fe&isComponent&outputPath=components%2Fbtn-outline-primary-active6d8cbf95%2Findex"
import script from "./btn-outline-primary-active.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-outline-primary-active6d8cbf95%2Findex"
export * from "./btn-outline-primary-active.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-outline-primary-active6d8cbf95%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports